/**
 * Created by rickborst on 26/07/2017.
 */

import _ from 'lodash';

import {
    convertForGetDevices,
    convertFromGetDevices,
    convertForAddDevice,
    convertFromAddDevice,
    convertFromAddDeviceError,
    convertForDeleteDevice,
    convertFromDeleteDevice,
    convertForDeleteDevices,
    convertFromDeleteDevices
} from '../adapters/devices';
import {
    isValidResponse,
    isSuccessMultirequestResponse
} from '../validators/devices';
import Device from 'models/device';

/**
 * Returns all registered devices.
 *
 * @param {Object} [user] - User object.
 * @returns {Promise} Devices promise.
 */
function getDevices (user) {
    let chain = user
        ? Promise.resolve(user)
        : this._dataSources.getActiveUser();

    return chain.then(result => {
        let url = this._baseUrl + this._endPoints.deviceList,
            data = convertForGetDevices.call(this, result);

        return this.read(
            {
                url,
                data
            })
            .then(response => {

                if (!isValidResponse.call(this, response)) {
                    return Promise.reject(response);
                }

                return response;
            })
            .then(response => {
                let entries = convertFromGetDevices.call(this, response);

                return _.map(entries, entry => new Device(entry));
            });
    });

}

/**
 * Adds a device to the account.
 *
 * @param {Object} device - Device object.
 * @returns {Promise} Add device promise.
 */
function addDevice (device) {
    let url = this._baseUrl + this._endPoints.deviceAdd,
        data = convertForAddDevice.call(this, device);

    return this.create(
        {
            url,
            data
        })
        .then(response => {

            if (!isValidResponse.call(this, response)) {
                return Promise.reject(convertFromAddDeviceError.call(this, response));
            }

            return response;
        })
        .then(response => {

            return convertFromAddDevice.call(this, response);
        });
}

/**
 * Deletes a device from the account.
 *
 * @param {Object} device - Device object.
 * @returns {Promise} Delete device promise.
 */
function deleteDevice (device) {
    let url = this._baseUrl + this._endPoints.deviceDelete,
        data = convertForDeleteDevice.call(this, device);

    return this.destroy(
        {
            url,
            data
        })
        .then(response => {

            if (!isValidResponse.call(this, response)) {
                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {

            return convertFromDeleteDevice.call(this, response);
        });
}

/**
 * Deletes all devices from the account.
 *
 * @param {Array} devices - Array of devices.
 * @returns {Promise} Delete devices promise.
 */
function deleteDevices (devices) {
    let url = this._baseUrl + this._endPoints.multirequest,
        data = convertForDeleteDevices.call(this, devices);

    return this.destroy(
        {
            url,
            data
        })
        .then(response => {
            if (!isSuccessMultirequestResponse.call(this, response)) {
                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {

            return convertFromDeleteDevices.call(this, response);
        });
}

/**
 * Verifies a device by checking it agains the existing devices or otherwise adding it.
 *
 * @param {Object} device - Device object.
 * @returns {Promise} Verify device promise.
 */
function verifyDevice (device) {
    let {udid} = device;

    return getDevices.call(this)
        .then(devices => {

            if (_.some(devices, ['udid', udid])) {
                return Promise.resolve(true);
            }

            return addDevice.call(this, device);
        });
}

export {
    getDevices,
    addDevice,
    deleteDevice,
    deleteDevices,
    verifyDevice
};


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/devices.js